var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
    'owc-overlay',
    { 'owc-overlay--active': _vm.isActive || _vm.reactivated, 'owc-overlay--dark': _vm.isDarkMode },
  ],on:{"~mouseover":function($event){return _vm.handleMouseOver.apply(null, arguments)},"~mousedown":function($event){return _vm.handleMouseDown.apply(null, arguments)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }